module.exports = __webpack_public_path__ + "img/purchase8.e6034434.png";